/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The Address model module.
 * @module model/Address
 * @version v1
 */
export class Address {
  /**
   * Constructs a new <code>Address</code>.
   * @alias module:model/Address
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Address</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Address} obj Optional instance to populate.
   * @return {module:model/Address} The populated <code>Address</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Address();
      if (data.hasOwnProperty('bridge_id'))
        obj.bridge_id = ApiClient.convertToType(data['bridge_id'], 'String');
      if (data.hasOwnProperty('bridge_name'))
        obj.bridge_name = ApiClient.convertToType(data['bridge_name'], 'String');
      if (data.hasOwnProperty('created_at'))
        obj.created_at = ApiClient.convertToType(data['created_at'], 'String');
      if (data.hasOwnProperty('formatted'))
        obj.formatted = ApiClient.convertToType(data['formatted'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('latitude'))
        obj.latitude = ApiClient.convertToType(data['latitude'], 'String');
      if (data.hasOwnProperty('longitude'))
        obj.longitude = ApiClient.convertToType(data['longitude'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} bridge_id
 */
Address.prototype.bridge_id = undefined;

/**
 * @member {String} bridge_name
 */
Address.prototype.bridge_name = undefined;

/**
 * @member {String} created_at
 */
Address.prototype.created_at = undefined;

/**
 * @member {String} formatted
 */
Address.prototype.formatted = undefined;

/**
 * @member {String} id
 */
Address.prototype.id = undefined;

/**
 * @member {String} latitude
 */
Address.prototype.latitude = undefined;

/**
 * @member {String} longitude
 */
Address.prototype.longitude = undefined;

